import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { buildMxnCashoutDraft } from '../cashout-draft-builders';
import { CashoutDraft } from '../cashout-currency.types';
import {
  BITSO_MXN_PROTOCOL_OPTIONS,
  getBitsoMxClabeLabel,
  getBitsoMxClabePlaceholder,
  setupMxnCashoutForm,
  updateBitsoMxnValidators,
} from './mxn-form.logic';

@Component({
  selector: 'app-mxn-form',
  templateUrl: './mxn-form.component.html',
  styleUrl: '../../add-cashout.component.scss',
})
export class MxnFormComponent implements OnInit {
  @Input() ctx!: any;
  @Output() draftReady = new EventEmitter<CashoutDraft>();

  readonly bitsoMxProtocolOptions = BITSO_MXN_PROTOCOL_OPTIONS;

  ngOnInit(): void {
    setupMxnCashoutForm(this.ctx);
  }

  get bitsoMxClabeLabel(): string {
    return getBitsoMxClabeLabel(this.ctx);
  }

  get bitsoMxClabePlaceholder(): string {
    return getBitsoMxClabePlaceholder(this.ctx);
  }

  onBitsoMxProtocolChange(): void {
    updateBitsoMxnValidators(this.ctx);
  }

  saveTransaction(): void {
    const draft = buildMxnCashoutDraft(this.ctx);
    if (draft) {
      this.draftReady.emit(draft);
    }
  }
}
